import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import PhoneInput from 'react-phone-input-2';

const ContactForm = () => {
    const [phone, setPhone] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted");
    };

    return (
        <form onSubmit={handleSubmit} className="p-4 bg-white">

            {/* Full Name */}
            <div className="mb-4">
                <label className="form-label fw-semibold text-secondary">Full Name*</label>
                <input
                    type="text"
                    className="form-control form-control-lg fs-6 py-3"
                    placeholder="Enter your full name"
                    required
                />
            </div>

            <div className="row">
                {/* Email */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold text-secondary">Email*</label>
                    <input
                        type="email"
                        className="form-control form-control-lg fs-6 py-3"
                        placeholder="Enter your email"
                        required
                    />
                </div>

                {/* Contact No */}
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold text-secondary">Contact No.*</label>
                    <PhoneInput
                        country={'in'}
                        value={phone}
                        onChange={setPhone}
                        inputStyle={{
                            width: '100%',
                            height: '58px',
                            fontSize: '1rem',
                            borderRadius: '0.375rem'
                        }}
                        buttonStyle={{
                            backgroundColor: 'transparent',
                            borderRight: 'none',
                            borderRadius: '0.375rem 0 0 0.375rem'
                        }}
                        placeholder="Enter your contact no"
                    />
                </div>
            </div>

            {/* Message */}
            <div className="mb-4">
                <label className="form-label fw-semibold text-secondary">Message</label>
                <textarea
                    className="form-control fs-6"
                    rows="5"
                    placeholder="Enter your main text here..."
                ></textarea>
            </div>

            {/* Footer Section */}
            <div className="d-flex justify-content-between mt-4">
                <small className="text-muted mb-0">
                    We usually respond within 24–48 hours.
                </small>
                <button
                    type="submit"
                    className="btn px-5 py-2 fw-bold"
                    style={{
                        borderRadius: '50px',
                        border: '2px solid #5d5fef',
                        color: '#333',
                        letterSpacing: '1px',
                        fontSize: '0.9rem'
                    }}
                >
                    SEND MESSAGE
                </button>
            </div>
        </form>
    );
};

export default ContactForm;